export default function getShopifyVariant(params) {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams === null || urlParams === void 0 ? void 0 : urlParams.get('variant')) {
        if (!params) {
            params = { variant_id: urlParams.get('variant') };
        }
        params.variant_id = urlParams.get('variant');
    }
    return params;
}
//# sourceMappingURL=getShopifyVariant.js.map